// Uint8Array.fromBase64 / toBase64 / fromHex / toHex are Baseline since late 2025, but older
// Safari/Node builds lack them. Install minimal fallbacks so the rest of the code can rely on them.
type U8Ctor = typeof Uint8Array & {
  fromBase64?: (s: string, o?: { alphabet?: 'base64' | 'base64url' }) => Uint8Array;
  fromHex?: (s: string) => Uint8Array;
};
type U8Proto = Uint8Array & {
  toBase64?: (o?: { alphabet?: 'base64' | 'base64url'; omitPadding?: boolean }) => string;
  toHex?: () => string;
};

const C = Uint8Array as U8Ctor;
const P = Uint8Array.prototype as U8Proto;

if (typeof C.fromBase64 !== 'function') {
  C.fromBase64 = (s, o) => {
    let t = s.replace(/\s+/g, '');
    if (o?.alphabet === 'base64url') t = t.replace(/-/g, '+').replace(/_/g, '/');
    while (t.length % 4) t += '=';
    const bin = atob(t);
    const out = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
    return out;
  };
}
if (typeof P.toBase64 !== 'function') {
  P.toBase64 = function (this: Uint8Array, o) {
    let bin = '';
    for (let i = 0; i < this.length; i += 0x8000) {
      bin += String.fromCharCode(...this.subarray(i, i + 0x8000));
    }
    let s = btoa(bin);
    if (o?.alphabet === 'base64url') s = s.replace(/\+/g, '-').replace(/\//g, '_');
    if (o?.omitPadding) s = s.replace(/=+$/, '');
    return s;
  };
}
if (typeof C.fromHex !== 'function') {
  C.fromHex = (s) => {
    const t = s.replace(/\s+/g, '');
    if (t.length % 2 || /[^0-9a-fA-F]/.test(t)) throw new SyntaxError('invalid hex string');
    const out = new Uint8Array(t.length / 2);
    for (let i = 0; i < out.length; i++) out[i] = parseInt(t.substr(i * 2, 2), 16);
    return out;
  };
}
if (typeof P.toHex !== 'function') {
  P.toHex = function (this: Uint8Array) {
    let s = '';
    for (const b of this) s += b.toString(16).padStart(2, '0');
    return s;
  };
}

export {};
